export default __webpack_public_path__ + "bg_anli_jinrong011424e5.png";